"use client";

import styled from "@emotion/styled";
import { TAG_COLORS_MAP } from "~/designSystem/components/Tags/constants/tag";

type StyledTagProps = {
  $color: keyof typeof TAG_COLORS_MAP;
  $disabled: boolean;
  $isHoverable: boolean;
};

const getTagColor = (color: keyof typeof TAG_COLORS_MAP) => {
  return TAG_COLORS_MAP[color] ? TAG_COLORS_MAP[color] : TAG_COLORS_MAP.brown;
};

export const StyledTag = styled("div", {
  shouldForwardProp: prop =>
    !["$color", "$disabled", "$isHoverable"].includes(
      prop as keyof StyledTagProps,
    ),
})<StyledTagProps>`
  width: fit-content;
  pointer-events: ${({ $disabled }) => ($disabled ? "none" : "auto")};

  ${({ $color, $disabled, $isHoverable }) => {
    const colorTheme = getTagColor($color);
    const state = $disabled ? "disabled" : "default";

    return `
        background-color: ${colorTheme[state].backgroundColor};
        border: 1px solid ${colorTheme[state].borderColor};
  
        & .octolane-ds-tag-text {
          color: ${colorTheme[state].textColor};
          text-box: trim-both cap alphabetic;
          font-style: normal;
        }
  
        & svg {
          color: ${colorTheme[state].iconColor} !important;
        }
  
        ${
          !$disabled &&
          $isHoverable &&
          `
          &:hover {
            background-color: ${colorTheme.hover.backgroundColor};
            border-color: ${colorTheme.hover.borderColor};
            & .octolane-ds-tag-text {
              color: ${colorTheme.hover.textColor};
            }
            & svg {
              color: ${colorTheme.hover.iconColor} !important;
            }
          }
  
          &:focus {
            background-color: ${colorTheme.focus.backgroundColor};
            border-color: ${colorTheme.focus.borderColor};
            box-shadow: ${colorTheme.focus.boxShadow};
            & .octolane-ds-tag-text {
              color: ${colorTheme.focus.textColor};
            }
            & svg {
              color: ${colorTheme.focus.iconColor} !important;
            }
          }
  
          &:focus-visible {
            outline: none;
          }
        `
        }
      `;
  }}
`;
